import { Grid, Skeleton, Stack, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { UsersIcon } from "../UIElements/svgIcons";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../notification";
import { useMutation } from "@tanstack/react-query";
import { apiGetDashboardStats } from "../../api/dashboard";

export default function DashboardInfo() {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const { showNotification } = useNotificationService();

  const [info, setInfo] = useState({
    totalOpenPositions: 0,
    totalUnmannedShifts: 0,
    totalFullTimeStaff: 0,
    totalLocumStaff: 0,
  });

  useEffect(() => {
    mutation.mutate();
  }, []);

  const mutation = useMutation({
    mutationFn: () => apiGetDashboardStats(),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        if (!!data?.data?.data) {
          setInfo(data.data.data);
        } else {
          setInfo({
            totalOpenPositions: 0,
            totalUnmannedShifts: 0,
            totalFullTimeStaff: 0,
            totalLocumStaff: 0,
          });
        }
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });

  return (
    <Grid container>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!mutation.isPending ? (
          <InfoBox
            title={"⁠Staff head count (Full time)"}
            value={info.totalFullTimeStaff}
            icon={<UsersIcon />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!mutation.isPending ? (
          <InfoBox
            title={"Staff head count (Locum)"}
            value={info.totalLocumStaff}
            icon={<UsersIcon />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!mutation.isPending ? (
          <InfoBox
            title={"Open positions"}
            value={info.totalOpenPositions}
            icon={<UsersIcon />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>{" "}
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!mutation.isPending ? (
          <InfoBox
            title={"Unmanned Shift"}
            value={info.totalUnmannedShifts}
            icon={<UsersIcon />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>
    </Grid>
  );
}
